import styled from 'styled-components';
import Config from '@config';
import { SkeletonWrapper } from '@molecules/TwoTilesComponent/TwoTilesComponent.skeleton.styles';
import { rem } from 'polished';

export const StyledColumnComponent = styled.div<{ $widthPercent: string }>`
  flex-grow: 0;
  min-width: 0;
  width: 100%;

  ${SkeletonWrapper}:not(:first-child) {
    margin-top: ${rem(2)};

    ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
      margin-top: ${rem(60)};
    }
  }

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    max-width: ${(props) => props.$widthPercent};
    flex-basis: ${(props) => props.$widthPercent};
  }
`;
